import { jdiColorFetch } from '@/apis/colorFetchV2';

// 页面向下滚动获取数据
export const getProductFeeds = (
  options: { cuPage: number; pageSize: number; params?: any } = {
    cuPage: 1,
    pageSize: 10,
    params: {},
  },
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    const res = await jdiColorFetch('guide_homepage_getItemFeeds', {
      method: 'post',
      bodyQuery: {
        ...options,
        type: 'EXT-CHANNEL-NEWUSER-PRODUCT',
      },
    });
    if (res.code === '200') {
      resolve(res.data);
    } else {
      reject(res);
    }
  });
};

// 查询用户身份 是否是新人

export const getUserIdentity = (): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    const res = await jdiColorFetch('guide_homepage_getUserIdentity', {
      method: 'post',
      bodyQuery: { identityTypes: 'IDENTITY_NEWCOMER' },
    });

    if (res.code === '200') {
      resolve(res.data);
    } else {
      reject(res);
    }
  });
};
